import {createModel} from '@rematch/core';
import {RootModel} from './index';


interface DataState {

}


const INIT: DataState = {
    // avatars: {},
};

export const DATA = createModel<RootModel>()({
    state: INIT,
    reducers: {},
    effects: (DISPATCH) => ({}),
});
